<template>
  <div>
    <div class="flex p-3 justify-between">
      <div class="flex flex-row">
        <img :src="data.logo" alt="" class="w-8 h-8 rounded-full mr-2" />
        <div :class="{ lock: data.lock }">
          <h3 class="text-sm font-medium text-black">{{ data.name }}</h3>
          <p class="text-xs font-medium text-606770">Sponsored</p>
        </div>
        <div :class="{ lock: data.lock }">
          <span
            class="flex items-center rounded-md bg-pink-600 text-white py-1 px-2 ml-2"
            v-if="data.new"
          >
            <p class="text-sm font-medium">New</p>
          </span>
        </div>
      </div>
      <div
        :class="{ lock: data.lock }"
        class="flex gap-2 justify-left content-center items-center"
      >
        <div
          class="content justify-center items-center content-center mx-auto cursor-pointer w-8 h-8 rounded-lg border border-indigo-500 p-1 bg-white text-base leading-6 shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
          @click="toggleFavoriteState(data)"
          :class="{ 'bg-indigo-500 ': data.isFavorite }"
        >
          <div class="group w-full flex items-center justify-center">
            <div>
              <Icon name="Heart" fill="#fff" stroke="#667eea" class="w-6" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div
        class="mb-2"
        :class="{ clamp: primaryTextClamp, lock: data.lock }"
        @click="togglePrimaryTextClamp"
      >
        <p
          class="text-x p-3 pt-0 leading-4 whitespace-pre-wrap font-sans tracking-tight"
        >
          {{ data.primary_text }}
        </p>
      </div>
      <div class="relative">
        <div
          class="square"
          v-if="
            !data.lock &&
            data.media_source &&
            typeof data.media_source == 'string'
          "
        >
          <video
            class="w-full"
            controls
            v-if="data.media_source.includes('.mp4')"
          >
            <source :src="data.media_source" type="video/mp4" />
          </video>
          <img
            :src="data.media_source"
            alt=""
            class="advertisements__item__media"
            v-if="
              data.media_source.includes('.png') ||
              data.media_source.includes('.jpg') ||
              data.media_source.includes('.jpeg') ||
              data.media_source.includes('.jepg')
            "
          />
        </div>
        <div class="square mt-0" v-if="data.lock">
          <div
            class="flex items-center justify-center pb-0 mb-20 px-4 sm:px-6 lg:px-8"
          ></div>
        </div>
        <template v-if="data.lock">
          <UnlockFB class="relative top-0 unlock" />
        </template>
      </div>
      <div
        class="flex justify-between items-center p-3"
        :class="{ lock: data.lock }"
      >
        <div class="w-56 text-s">
          <p>{{ data.display_link }}</p>
          <p>{{ data.description }}</p>
          <p>{{ data.headline }}</p>
        </div>
        <button v-if="data.call_to_action" class="action rounded-md">
          {{ data.call_to_action }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import Icon from "@/components/UI/Icon";
import UnlockFB from "@/components/UnlockFB";
export default {
  components: { Icon, UnlockFB },
  props: {
    data: Object,
    isCollection: Boolean,
    lock: Boolean,
  },
  setup() {
    const store = useStore();
    const primaryTextClamp = ref(true);
    const user = computed(() => store.state.user);
    const roleUser = computed(() => store.state.role);

    const togglePrimaryTextClamp = () => {
      primaryTextClamp.value = !primaryTextClamp.value;
    };
    // const openOurPlansModal = () => {
    //   store.commit("SET_OURPLANS_ACTIVE", true);
    // };
    const toggleFavoriteState = async (ad) => {
      if (ad.isFavorite) {
        await store.dispatch("REMOVE_FAVORITE_ADD", {
          user_id: user.value.id,
          advertisement_id: ad.id,
        });
      } else {
        await store.dispatch("ADD_FAVORITE_AD", {
          user_id: user.value.id,
          advertisement: ad,
        });
      }
    };

    return {
      roleUser,
      primaryTextClamp,
      togglePrimaryTextClamp,
      toggleFavoriteState,
    };
  },
};
</script>

<style>
.post {
  filter: blur(8px);
}
.unlock {
  z-index: 1;
}
.lock {
  filter: blur(12px);
  pointer-events: none;
}
.text-606770 {
  color: #606770;
}
.square {
  width: 100%;
  background-color: black;
}
.clamp {
  max-height: calc(1rem * 7);
  display: -webkit-box;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.advertisements__item__media {
  width: 100%;
}
.action {
  max-width: 100px;
  letter-spacing: normal;
  color: rgb(68, 73, 80);
  font-size: 12px;
  font-weight: bold;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, Arial, sans-serif;
  line-height: 26px;
  text-align: center;
  height: 30px;
  background-position: 0 0;
  border: 1px solid #667eea;
  border-radius: 10px;
  box-shadow: none;
  box-sizing: border-box;
  cursor: pointer;
  -webkit-font-smoothing: antialiased;
  font-weight: bold;
  padding: 0 11px;
  position: relative;
  text-shadow: none;
  transition: all 300ms cubic-bezier(0.1, 0.7, 0.1, 1), border-width 1ms;
  transition-property: background, border-color, border-width, color;
  vertical-align: middle;
}
</style>
